module.exports = __webpack_public_path__ + "static/img/dialog_money.785a98c3.gif";